// extracted by mini-css-extract-plugin
export var downArrow = "_7o-0";
export var infoTooltipIcon = "_7o-3";
export var label = "_7o-1";
export var optionCard = "_7o-4";
export var upArrow = "_7o-2";